import { DateRangePicker as DateRangePickerComp } from "react-date-range";

import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file

import { Box } from "@mui/material";

const DateRangePicker = ({ onChange, state }) => {
  return (
    <Box mb={4} sx={{ width: "100%" }}>
      <DateRangePickerComp
        onChange={onChange}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={2}
        ranges={state}
        direction="horizontal"
      />
    </Box>
  );
};

export default DateRangePicker;
